// src/components/Timer/CompletionPlayer.js

import React from 'react';
import YouTube from 'react-youtube';
import PropTypes from 'prop-types';

export default function CompletionPlayer({ playUrl, onEnd }) {
  if (!playUrl) return null;

  const isYouTube = /youtube\.com|youtu\.be/.test(playUrl);

  const extractVideoId = url => {
    try {
      const u = new URL(url);
      const hostname = u.hostname;
      if (hostname.includes('youtu.be')) return u.pathname.slice(1);
      if (hostname.includes('youtube.com')) return u.searchParams.get('v');
    } catch {
      const m = url.match(/(?:youtube\.com\/.*v=|youtu\.be\/)([^&?/]+)/);
      return m ? m[1] : null;
    }
    return null;
  };

  if (isYouTube) {
    const videoId = extractVideoId(playUrl);
    if (!videoId) {
      onEnd();
      return null;
    }
    return (
      <YouTube
        key={videoId}
        videoId={videoId}
        opts={{
          height: '0',
          width: '0',
          playerVars: { autoplay: 1, controls: 0, rel: 0, modestbranding: 1 },
        }}
        onStateChange={event => {
          if (event.data === 0) onEnd();
        }}
        onError={onEnd}
        style={{ display: 'none' }}
      />
    );
  }

  return (
    <audio
      key={playUrl}
      src={playUrl}
      autoPlay
      onEnded={onEnd}
      onError={onEnd}
      style={{ display: 'none' }}
    />
  );
}

CompletionPlayer.propTypes = {
  playUrl: PropTypes.string.isRequired,
  onEnd: PropTypes.func.isRequired,
};
